import { AuthRoute } from "../../components/public/auth/AuthRoute";

export const SignIn = () => <AuthRoute view="signin" />;
